import React from 'react';
import { motion } from 'framer-motion';
interface PageTransitionProps {
  children: React.ReactNode;
}
/**
 * Wraps a page in a smooth fade + subtle upward slide on enter/exit.
 * Used together with AnimatePresence keyed on the route.
 */
export function PageTransition({
  children
}: PageTransitionProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 12
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -8
  }} transition={{
    duration: 0.4,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-574">
      {children}
    </motion.div>;
}